import type { MonitoringSnapshot } from '../../monitoring/types/monitoring.types';
import type { DashboardOverview } from '../types/dashboard.types';

export function getActiveServiceCount(monitoring: MonitoringSnapshot | null): number | null {
  if (!monitoring) return null;
  return Object.values(monitoring.services).filter((service) => service.status === 'ok' || service.status === 'healthy').length;
}

export function getSystemHealthLabel(monitoring: MonitoringSnapshot | null, loading: boolean): string {
  if (loading) return '—';
  if (!monitoring) return 'در دسترس نیست';
  return monitoring.status === 'ok' || monitoring.status === 'healthy' ? 'پایدار' : monitoring.status;
}

export function getControlPlaneMetricValues(dashboard: DashboardOverview, monitoring: MonitoringSnapshot | null, monitoringLoading: boolean) {
  const activeServices = getActiveServiceCount(monitoring);
  return {
    activeTenants: dashboard.tenants.active_tenants,
    activeUsers: dashboard.overview.active_users,
    activeServices,
    systemHealth: getSystemHealthLabel(monitoring, monitoringLoading),
  };
}
